import React from 'react';
import { createRoot } from 'react-dom/client';
import { connect, Provider } from 'react-redux';
import { ModelManager, Constants } from '@adobe/aem-spa-page-model-manager';
import utils from 'utils';
import App from '../App';

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default {
  init(store, domEl) {
    ModelManager.initialize({
      // The `path` configuration controls what the current page views as the `model.json` URL. We update this with the
      // query string from the parent page to allow pass down of query params like the `nocache` param.
      path: utils.url.getModelJsonPathWithQueryString(),
    }).then((model) => {
      const Container = connect(mapStateToProps, mapDispatchToProps)(App);
      // Render App
      const root = createRoot(domEl.getElementById('root'));
      root.render(
        <Provider store={store}>
          <Container
            cqChildren={model[Constants.CHILDREN_PROP]}
            cqItems={model[Constants.ITEMS_PROP]}
            cqItemsOrder={model[Constants.ITEMS_ORDER_PROP]}
            cqPath={model[Constants.PATH_PROP]}
            locationPathname={window.location.pathname}
          />
        </Provider>
      );
    });
  },
};
